import React, { useState } from 'react'
import { func, node } from 'prop-types'
import qs from 'query-string'
import { searchHandler } from 'redux/actions/searchActions'
import {
  PAGE_TYPES,
  SET_LOCATION_DATA_FOR_SEARCH,
} from 'settings/app/constants'
import { useDispatch } from 'react-redux'
import { getEntryPoint, validCoordinates } from 'settings/app/helpers'

/**
 * handle all get params based requests
 * @param children
 * @param onPerformSearch
 * @returns {JSX.Element}
 * @constructor
 */
const UrlParser = ({ children, onPerformSearch }) => {
  const dispatch = useDispatch()
  const [isSeoSearched, setIsSeoSearched] = useState(false)
  const entryPoint = getEntryPoint()

  /**
   * Deep link && entryPoint Reset
   */
  const readGetParams = () => {
    let params = qs.parse(window.location.search)
    if (Object.keys(params).length > 0) {
      // convert array values into booleans
      Object.keys(params).forEach((key) => {
        if (Array.isArray(params[key])) {
          params[key] = true
        }
      })

      // parse location coordinates
      if (
        SET_LOCATION_DATA_FOR_SEARCH.includes(entryPoint) &&
        !!params.lat &&
        !!params.lng
      ) {
        let lat = parseFloat(params.lat)
        let lng = parseFloat(params.lng)

        // no valid coordinates, set as false to store
        if (!validCoordinates(lat, lng)) {
          lat = false
          lng = false
        }

        params = { ...params, lat, lng }
      }

      dispatch(searchHandler('deepLinkSearch', params))
    }
  }

  /**
   * reload results on browser navigation (backspace)
   */
  React.useEffect(() => {
    readGetParams()
  }, []) // eslint-disable-line

  /**
   * handle pageType seo
   */
  React.useEffect(() => {
    const pageType = localStorage.getItem('pageType')
    if (pageType === PAGE_TYPES.SEO_PAGE && !isSeoSearched) {
      // if (!isMobile) toggleMapFullscreen(true)
      let params = {}

      // seo page requires key && type
      // hmmmmmm hmmmmmmmm²
      if (pageType === PAGE_TYPES.SEO_PAGE) {
        params = {
          query: localStorage.getItem('searchQuery'),
          location: localStorage.getItem('searchLocation'),
          radius: parseInt(localStorage.getItem('searchRadius'), 10),
          key: localStorage.getItem('searchKey'),
          type: localStorage.getItem('searchType'),
        }

        if (!isNaN(parseInt(localStorage.getItem('searchRadius'), 10))) {
          params.radius = parseInt(localStorage.getItem('searchRadius'), 10)
        } else {
          params.radius = 0
        }
      }

      // https://bugs.onedev.aok.de/browse/MGMNAVSUP-189
      setIsSeoSearched(true)

      // force initial search
      onPerformSearch('initialSearch', params)
    }
  }, [onPerformSearch, isSeoSearched])

  return <>{children}</>
}

UrlParser.propTypes = {
  children: node.isRequired,
  onPerformSearch: func.isRequired,
}

export default UrlParser
